<template>
  <b-modal
    size="md"
    :style="{ zIndex: 200 }"
    v-model="isVisible"
    class="modal"
    hide-footer
    no-close-on-backdrop
  >
    <template v-slot:modal-header="{ cancel }">
      <h5 class="modal-title">Add User Profile</h5>
      <button
        type="button"
        aria-label="Close"
        class="close"
        @click.prevent="cancel"
      >
        <span class="material-icons"> close </span>
      </button>
    </template>

    <FormGenerator
      ref="form"
      :data="createProfile.form"
      @input="inputFormField"
      :isLoading="loading"
      @submit="submit"
    >
      <template v-slot:skills="{ data }">
        <b-form-group>
          <label>{{ data.label }}</label>
          <UserProfileSkills v-model="data.value" />
        </b-form-group>
      </template>
    </FormGenerator>

    <template v-slot:modal-footer="{ cancel }">
      <b-button variant="outline" class="button" @click.prevent="cancel">
        Cancel
      </b-button>
      <b-button variant="primary" class="button" @click.prevent="submitModal">
        Create
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import FormGenerator from '@components/FormGenerator'
import UserProfileSkills from '@components/UserProfileSkills'
import UserMixin from '@mixins/UserMixin'

export default {
  components: {
    FormGenerator,
    UserProfileSkills
  },
  mixins: [UserMixin],

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      loading: false
    }
  },

  mounted () {
    this.setAllPartners()
  },

  computed: {
    ...mapGetters({
      getAllPartners: 'partners/getAllPartners'
    }),

    isVisible: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },

  methods: {
    setAllPartners () {
      this.$api.partners.getAllPartners()
        .then(() => {
          this.createProfile.form.partner.options = this.getAllPartners
          this.editProfile.form.partner.options = this.getAllPartners
        })
    },

    inputFormField (fields) {
      if (fields.employment_type.value && fields.employment_type.value.name === 'partner') {
        fields.partner.hidden = false
      } else {
        fields.partner.hidden = true
      }
    },

    submit (data) {
      const formData = this.prepareDataForRequest(data)
      this.loading = true

      this.axios.post(
        `/api/users/profiles`,
        formData,
        {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        }).then(response => {
        if (response.status === 200) {
          this.$snotify.success('User profile successfully created', 'Success', this.$store.state.snotify)
        }

        this.isVisible = false
        this.$emit('change')
      }).catch(err => {
        const errors = Object.values(err.response.data.errors)
        for (let i = 0; i < errors.length; i++) {
          this.$snotify.error(errors[i][0], 'Error', this.$store.state.snotify)
        }
      }).finally(() => {
        this.loading = false
      })
    },

    submitModal () {
      this.$refs.form.submit()
    }
  }
}
</script>
